import localSettings from "../../config/localSettings";
var URL_SETTINGS = "/settings.json";
var storedSettings = null;
/**
 * Store the settings and return it
 * @param {{ apiEndpoint: string, oidc_authority: string, oidc_client_id: string }} settings
 * @returns {{ apiEndpoint: string, oidc_authority: string, oidc_client_id: string }}
 */ export var storeSettingsAndReturn = function(settings) {
    storedSettings = settings;
    return settings;
};
/**
 * Get the settings which contains api endpoint and auth config
 * If settings is not present returns the local settings
 * @returns {Promise<{ apiEndpoint: string, oidc_authority: string, oidc_client_id: string }>}
 */ export var getSettings = function() {
    if (storedSettings) {
        return Promise.resolve(storedSettings);
    }
    return fetch(URL_SETTINGS).then(function(response) {
        return response.json();
    }).then(function(settings) {
        return storeSettingsAndReturn(settings);
    }).catch(function() {
        return storeSettingsAndReturn(localSettings);
    });
};
export default getSettings;

//# sourceMappingURL=getSettings.js.map